import { Route, Routes } from "react-router-dom";
import CurriculumBuilderRoutes from "./CurriculumBuilder";
import TestsRoutes from "./Tests";
import ChallengesRoutes from "./Challenges"
import LessonsRoutes from "./Lessons";
import CategoriesRoutes from "./Categories";

export default function CurriculumRouter() {
  return (
    <Routes>
      <Route path="/build/*" element={<CurriculumBuilderRoutes />} />
      <Route path="/tests/*" element={<TestsRoutes />} />
      <Route path="/challenges/*" element={<ChallengesRoutes />} />
      <Route path="/lessons/*" element={<LessonsRoutes />} />
      <Route path="/categories/*" element={<CategoriesRoutes />} />
    </Routes>
  );
}
